module.exports = __webpack_public_path__ + "img/hdp-portfolio.86c6dc23.jpg";